<template>
<div>

    <v-dialog
      v-model="dialog"
      max-width="600px"
    >

      <v-card class="rounded-lg">
        <v-toolbar
          class="mb-9 text-center"
          color="mygreen"
          dark>休暇申請削除</v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="text-left" cols="12">休暇申請を削除してもよろしいでしょうか？<br>
この操作は取消し出来ません。</v-col>
            </v-row>

          </v-container>
        </v-card-text>

        <v-card-actions class="pb-6">
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            @click="dialog = false">戻る</v-btn>
          <v-btn dark
            color="mygreen"
            @click="mydelete()">決定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>


<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import myMixin from '@/mixin.js';
import axios from 'axios';
import {mapGetters} from 'vuex'
/* eslint-disable */



export default {

    mixins: [myMixin],
    created() {
        console.log('%ccreated: DialogKyukaDelete.vue', mycolor.created);
    },


    // datas
    data() {
            return {
                kyuka_id: null,

                dialog: false,
            }
    },
    computed: {
        ...mapGetters(['user', 'user_name', 'is_admin']),
    },
    methods: {
/* eslint-disable */
        open(item){
            console.group();
            console.log('open()');
            console.log('item: ', item);
            console.groupEnd();

            if( this.user.auth==='一般' ){
                this.staff_selected = this.user.id;
            }

            if(item){
                this.kyuka_id = item.id;
            }


            this.dialog = true;
        },
        mydelete(){
            console.log('mydelete()');

            this.setToken();
            axios.post('/kyuka_delete/'+this.kyuka_id)
              .then((res) => {
                  console.group();
                  console.log('%c /kyuka_delete', mycolor.api);
                  console.log(res.data);
                  console.groupEnd();
                  this.$emit('getkyukalist');  // 親側で休暇リストの取得し直しを要求


                  // メール送信
                  if(res.data.status==='OK'){
                      console.log('%c onegaisimasu', mycolor.strong);
                      axios.post('/send_kyuka_mail/6', res.data.data)
                      .then( (res) => {
                          console.log('%c /send_kyuka_mail/6', mycolor.api);
                          console.log(res);
                      })
                      .catch( e => console.log(e));
                  }


              })
              .catch( (e) => {
                      console.log(e);
                      let detailMessage = e?.response?.data?.detail || '不明なエラーが発生しました。';
                      alert('エラーが発生しました。' + detailMessage);
                  }
              );

              this.dialog = false;

        }  // mydelete()

/* eslint-disable */

    }, // methods
}
</script>

<style scoped>
/deep/ .v-input__append-inner{
    margin: auto !important;
}
/deep/ .row > div {
/*    height: 70px; */
}
/deep/ .v-list-item__content{
    text-align: left;
}
/deep/ .theme--light.v-input{
    margin-top: -8px;
}
/deep/ .v-select__slot{
    height: 40px;
}
/deep/ .v-dialog > .v-card > .v-card__text{
    padding-bottom: 0px;
}
/deep/ .v-toolbar__content{
    text-align: center;
}
</style>
